import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { FieldDiamond } from './FieldDiamond';
import { coaches } from '../data/coaches';
const chips = ['6 Volumes', '5 Bonuses', '300+ Pages', '37 Ready-to-Run Practices', 'A full season, planned'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];
export function Hero() {
  return <section className="wood-bench relative w-full overflow-hidden border-b-4 border-gold" data-id="element-111" data-mp="128z14h6wu40r">
      {/* Chalk-diamond cover motif, like the product covers */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-112" data-mp="sart4nulmwaw">
        <FieldDiamond className="absolute -left-16 top-28 h-[300px] w-[300px] text-ice/[0.06] sm:h-[360px] sm:w-[360px]" data-id="element-113" data-mp="nc85mj0cxcgf" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-114" data-mp="3d2l95b1th306">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-115" data-mp="3825wymt9u1js">
          <div data-id="element-116" data-mp="3j7zc59vbxccg">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-117" data-mp="3j9kazboofhg4">
              The season-ready system for youth baseball coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-4xl leading-[.91] tracking-tight sm:text-6xl md:text-7xl" data-id="element-118" data-mp="39al9cd2bwm2m">
              Your next baseball practice is{' '}
              <span className="text-gold" data-id="element-119" data-mp="30i19j9aawbg7">already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-120" data-mp="30fybq32wpe0x">
              Baseball Practice Ready is a six-volume coaching system: a full
              season of fun, ready-to-run practices &mdash; drills, game-day
              plans and printable sheets. Not a pile of drills to sort through:
              the practice itself, timed and sequenced, ready to run.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-121" data-mp="2hl9puyqujubm">
              {chips.map(chip => <li key={chip} className="rounded-md border border-ice-dark/40 bg-ice-dark/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ice-dark" data-id="element-122" data-mp="2lmuzmb833shl">
                  {chip}
                </li>)}
            </ul>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/vRrAw4Eu4tPkAsF5WTye1o/DPS30-hero.png" alt="The six Baseball Practice Ready volumes lined up on the field at sunset, with kids practicing in the background" width={2048} height={1360} className="w-full h-auto rounded-2xl shadow-card" data-id="element-123" data-mp="dd5c6kb95b20" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-124" data-mp="110wr7vo6g26z">
          <div className="w-full max-w-md" data-id="element-125" data-mp="x1wb4kx33dno">
            <CtaButton data-id="element-126" data-mp="x37am8jhxz8z">Get Baseball Practice Ready</CtaButton>
          </div>
          <div className="mt-5 flex flex-col items-center gap-2.5 sm:flex-row sm:gap-4" data-id="element-127" data-mp="3luiaiu6w15my">
            <ul className="flex -space-x-2.5" data-id="element-128" data-mp="3hqkbsklh5wuf">
              {coaches.map(coach => <li key={coach.name} data-id="element-129" data-mp="1xaceczu3ndrn">
                  <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-10 w-10 rounded-full border-2 border-navy-deep object-cover" data-id="element-130" data-mp="1x785hp5ovtun" />
                </li>)}
            </ul>
            <div className="text-center sm:text-left" data-id="element-131" data-mp="2fyr8vx3ml9x7">
              <span className="flex justify-center gap-0.5 sm:justify-start" aria-label="Rated 4.9 out of 5" data-id="element-132" data-mp="2kyvn1gh29sk9">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-133" data-mp="2tzbq4otw6xol" />)}
              </span>
              <p className="mt-1 text-xs text-white/65" data-id="element-134" data-mp="zkr8kl0vbi9f">
                <span className="font-bold text-white" data-id="element-135" data-mp="zndrfgt7lk6y">4.9/5</span> from 1,200+
                coaches running this system
              </p>
            </div>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-136" data-mp="3vh5k87gl987q">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-137" data-mp="9ah476xnerzr">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-138" data-mp="9b8ohllsp3aq" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}